import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Box } from "@similarweb/ui-components/foundations";

import { TreeSelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/TreeSelectCombobox/TreeSelectCombobox";
import type { TreeSelectSource } from "app/pages/sales-intelligence/common-components/dropdown/TreeSelectCombobox/types";

import signalRecommenderI18nKeys from "../../utils/i18n";

import { SignalFilterCategoryTrigger } from "./SignalFilterCategoryTrigger";

type SignalFilterCategoryPanelProps<TId extends string> = {
    readonly title: string;
    readonly viewModel: TreeSelectSource<TId>;
    readonly selectedIds: readonly TId[];
    readonly dataAutomation: string;
    readonly onChange: (next: readonly TId[]) => void;
};

export const SignalFilterCategoryPanel = <TId extends string>({
    title,
    viewModel,
    selectedIds,
    dataAutomation,
    onChange,
}: SignalFilterCategoryPanelProps<TId>): ReactElement => {
    const { translate } = useTranslate();

    return (
        <Box
            width="100%"
            minWidth={0}
            data-automation={dataAutomation}
        >
            <TreeSelectCombobox
                viewModel={viewModel}
                onChange={onChange}
                dataAutomation={dataAutomation}
                searchPlaceholder={translate(signalRecommenderI18nKeys.confirm.filters.searchPlaceholder)}
                expandLabel={translate(signalRecommenderI18nKeys.confirm.filters.expandAria)}
                collapseLabel={translate(signalRecommenderI18nKeys.confirm.filters.collapseAria)}
                matchTriggerWidth
                trigger={({ isOpen, isDisabled }) => (
                    <SignalFilterCategoryTrigger
                        dataAutomation={`${dataAutomation}-trigger`}
                        title={title}
                        selectedCount={selectedIds.length}
                        isOpen={isOpen}
                        isDisabled={isDisabled}
                    />
                )}
            />
        </Box>
    );
};
